import '@fontsource/lato/300.css';
import '@fontsource/lato/400.css';
import '@fontsource/lato/700.css';
import './styles.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { ThemeProvider } from './theme.tsx';

/**
 * One origin, decided before anything reads it.
 *
 * www.theslate.day is served so that typing it works, but an origin is where
 * localStorage lives and where `window.location.origin` — the magic link's
 * return address — comes from. Two of them means a session and a chosen
 * palette that do not follow you between two URLs for the same app, and a
 * second entry needed in Supabase's redirect allow-list or sign-in fails
 * outright on the one people are most likely to type.
 *
 * It runs before React mounts and before any client is constructed, so
 * nothing has read the wrong origin by the time it happens. `replace`, not
 * `assign`: the wrong host should not be a place the back button returns to.
 */
if (location.hostname === 'www.theslate.day') {
  location.replace(`https://theslate.day${location.pathname}${location.search}${location.hash}`);
}

const root = document.getElementById('root');
if (!root) throw new Error('No #root element');

createRoot(root).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);
